"use strict";

import React from 'react';
import ProductGallerySlideImage from "./ProductGallerySlideImage";
import ProductGallerySlideVideo from "./ProductGallerySlideVideo";
import ProductGallerySlideCaption from "./ProductGallerySlideCaption";

const ProductGallerySlide = ({slide={},
                             slideAltText='',
                             magnifierProps={},
                             magnifyImage=true,
                             videoProps={} }) => {
    const slideCategory = !!slide.category ? slide.category : '';
    return (
        <React.Fragment>
            {slideCategory === 'IMAGE' &&
            <ProductGallerySlideImage slide={slide} imgAlt={slideAltText} magnifierProps={magnifierProps} magnifyImage={magnifyImage} />
            }
            {slideCategory === 'VIDEO' &&
            <ProductGallerySlideVideo slide={slide} videoProps={videoProps} />
            }
            {slide.caption &&
                <ProductGallerySlideCaption caption={slide.caption} title={slide.title} />
            }
        </React.Fragment>
    );
};

export default ProductGallerySlide;
